import { AnyAction } from 'redux';
import { FormatData } from 'src/store/format/types';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import { setCurrentFormatAction } from 'src/store/format/slice';
import { Feature } from 'src/store/app/types';
import isFeatureEnabled from 'src/util/feature/isFeatureEnabled';
import { clearClipArtCategoriesAction } from 'src/store/addon/slice';
import fetchClipArtCategoryOperation from 'src/store/addon/operation/fetchClipArtCategoryOperation';
import getPrintingMethod from '../selector/getPrintingMethod';
import {
  setDesignIsLoadingAction,
  setDesignEncPublicIdAction,
  setDesignProductIdAction,
  setDesignCategoryIdAction,
  setDesignProductUidAction,
  setDesignInternalUidAction,
} from '../slice';
import updateProductAttributesOperaion from './updateProductAttributesOperaion';

const designFormatChangedOperation = (format: FormatData) => async (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  const prevPrintingMethod = getPrintingMethod(getState());

  dispatch(setDesignProductUidAction(format.productUid));
  dispatch(setDesignInternalUidAction(format.internalUid));
  dispatch(updateProductAttributesOperaion());
  dispatch(setDesignEncPublicIdAction(format.encPublicDesignId));
  dispatch(setDesignProductIdAction(format.productId));
  dispatch(setDesignCategoryIdAction(format.categoryId));
  dispatch(setCurrentFormatAction(format));
  dispatch(setDesignIsLoadingAction(false));

  // When the active product's printing method changes mid-session, the cached
  // catalog results are sorted for the previous method - clear and re-fetch so
  // the picker re-sorts for the new method.
  const nextPrintingMethod = getPrintingMethod(getState());
  if (isFeatureEnabled(Feature.supportClipArt) && prevPrintingMethod !== nextPrintingMethod) {
    dispatch(clearClipArtCategoriesAction());
    await dispatch(fetchClipArtCategoryOperation());
  }
};

export default designFormatChangedOperation;
